// Global CSS classes
export enum GlobalClass {
  ButtonPlain = "buttonPlain",
  HideText = "hideText",
  TextTooltipUnderline = "textTooltipUnderline",
  Uppercase = "uppercase",
}
